import { Component, ContentChild, EventEmitter, Inject, Input, Optional, Output, TemplateRef, ViewChild } from "@angular/core";
import { Breakpoints, NguCarouselConfig } from "../ngu-carousel/ngu-carousel";
import { PageConfig, Summary } from "../../models/tile-config.model";
import { NguCarousel } from "../ngu-carousel/ngu-carousel.component";

@Component({
    selector: 'nxi-carousel',
    templateUrl: './nxi-carousel.component.html'
})
export class NxiCarouselComponent {
    
    @ViewChild('myCarousel') myCarousel: NguCarousel<any>;
    @ContentChild(TemplateRef) customContent: TemplateRef<any>;

    pageConfig: PageConfig;
    @Input() set config(pageConfig: PageConfig) {
        if(pageConfig) {
            this.pageConfig = pageConfig;
            this.setCarouselConfig(pageConfig);
        }
    }

    summary: Summary[];
    @Input() set carouselData(summary: Summary[]){
        if(summary) {
            this.summary = summary;
            this.myCarousel?.moveTo(0, true);
        }
    }

    @Output() onTileClick = new EventEmitter<Summary>();

    carouselConfig: NguCarouselConfig;

    enableTouch: boolean;
    constructor(@Optional() @Inject('AppSettings') appSettings: any,) {
        this.enableTouch = appSettings.deviceType !== 'desktop';
    }

    setCarouselConfig(pageConfig: PageConfig) {

        let grid = {
            xs: pageConfig.tilesPerResolution.xSmall,
            sm: pageConfig.tilesPerResolution.small,
            md: pageConfig.tilesPerResolution.medium,
            lg: pageConfig.tilesPerResolution.large,
            xl: pageConfig.tilesPerResolution.xLarge,
            all: 0 
        }
       
        this.carouselConfig = {
            grid: grid,
            gridBreakpoints: new Breakpoints(576, 768, 992, 1200),
            speed: 500,
            point: {
            visible: true
            },
            load: 2,
            velocity: 0,
            touch: this.enableTouch,
            easing: 'cubic-bezier(0, 0, 0.2, 1)'
        }
    }

    onClick(summary: Summary) {
        console.log('inside-click', summary);
        if(!(summary.highlight)) {
            let index = this.summary.findIndex(e => e.highlight === true)
            if(index !== -1) {
                this.summary[index].highlight = false;
            }
            summary.highlight = true;
            this.onTileClick.emit(summary);
            console.log('event-emitted', summary);
        }
    }
}